import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney } from "../Helpers";

export default function View({ data }) {

	const appContext = useContext(AppContext);

	/* Place states here */

	function view() {
		appContext.navTo({
			item: 'side-view',
			subItem: 'student-options',
			extraItem: data.uuid,
		})
	}

	return (
		<div className="One" onClick={view}>
			<div className="row">

				<div className="col-12">
					<h6
						style={{
							fontSize: "18px"
						}}
						className="font-semi-bold mb-4"
					>
						{data.firstName} {data.middleName} {data.lastName}
					</h6>
					<h6
						style={{
							fontSize: "14px"
						}}
						className="font-semi-bold"
					>
						<span className="font-light">Classroom: </span> {data.classroomName}
					</h6>
					<h6
						style={{
							fontSize: "14px"
						}}
						className="font-semi-bold"
					>
						<span className="font-light">Stream: </span> {data.streamName || "N/A"}
					</h6>
				</div>
				
				

			</div>
		</div>
	)

}